export default __webpack_public_path__ + "static/media/digital-empire-big-3@2x.a4e824dd.png";